module.exports = __webpack_public_path__ + "static/media/001-Ueberzeugen_ID_14.e44ab69a.mp3";